import Service from "../../AuthService";
const ElectricityBill = {
    getElectricityBill(page,rental_fee_id) {
        return Service.get("/electricity_bill?page="+page+
            "&rental_fee_id="+rental_fee_id);
    },
    showElectricityBill(id) {
        return Service.get("/electricity_bill/" + id);
    },
    updateElectricityBill(id, data) {
        return Service.put("/electricity_bill/" + id, data);
    },
    createElectricityBill(data) {
        return Service.post("/electricity_bill", data);
    },
    deleteElectricityBill(id) {
        return Service.delete("/electricity_bill/" + id);
    },
    getElectricityBillByRentalFeeID(rental_fee_id,page){
        return Service.get("/rental_fee_electricity_bill/" + rental_fee_id+"?page="+page);
    }
};
export default ElectricityBill;
